<template>
  <v-row justify="center">
    <v-dialog
      v-model="displaySelf"
      persistent
      max-width="640px"
    >
      <v-card>
        <v-card-title>
          <span class="headline">Вопросы вакансии: {{ `${vacancy.title}` }}</span>
        </v-card-title>
        <v-card-text>
          <DataList
            :headers="headers"
            :paginator="{total: 20}"
            :data="modelList"
            :loading="dataLoading"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="blue darken-1"
            text
            @click="$emit('onCloseVacancyQuestionListModal')"
          >
            Закрыть
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>
<script>
import DataList from '@/components/common/list/data-list/index'

export default {
  name: 'VacancyQuestionModal',
  components: { DataList },
  props: {
    displaySelf: {
      type: Boolean,
      default: false,
    },
    vacancy: {
      type: Object,
    }
  },
  data: () => ({
    dataLoading: false,
    modelList: [],
    headers: [
      {
        text: 'Вопрос',
        align: 'left',
        sortable: false,
        value: 'title',
      },
      {
        text: 'Приоритет',
        align: 'left',
        sortable: false,
        value: 'priority',
      },
    ]
  }),
  computed: {
  },
  created () {
    this.requestList()
  },
  methods: {
    async requestList () {
      this.showPageLoader()
      // this.tableLoading = true
      try {
        const list = await this.$store.dispatch(
          'organization/getVacancyQuestionList',
          { id: this.vacancy.id }
        )
        this.modelList = list.data

        this.tableLoading = false
        this.hidePageLoader()
      } catch (error) {
        console.log(error)
        this.tableLoading = false
        this.hidePageLoader()
      }
    }
  }
}
</script>
